import { apiClient } from './api-client';

/**
 * Chamadas do login global (SSO iniciado pelo destino) a partir da tela
 * `/authorize`. Diferente do resto do app, o `x-scope-id` aqui é o do **destino**
 * (vem na query da URL), não o `VITE_SCOPE_ID` fixo do `apiClient` — por isso o
 * override por chamada. O Bearer continua saindo do interceptor do `apiClient`
 * (sessão Firebase atual). Ver `primum-core-root/docs/plans/ready/login-global-sso.md` §5.
 */

export interface SsoTarget {
  platformName: string;
}

export interface SsoCodeResult {
  /** URL de volta já montada pelo servidor (`redirect_uri?code=…&state=…`). */
  redirectUrl: string;
}

export interface IssueSsoCodeInput {
  scopeId: string;
  redirectUri: string;
  state: string;
  codeChallenge: string;
}

/** Pública: valida o destino e devolve o nome da plataforma para a tela. */
export async function fetchSsoTarget(
  scopeId: string,
  redirectUri: string,
): Promise<SsoTarget> {
  const { data } = await apiClient.get<SsoTarget>('/auth/sso/target', {
    params: { scopeId, redirectUri },
  });
  return data;
}

/** Emite o code para o usuário autenticado, com `x-scope-id` = destino. */
export async function issueSsoCode(
  input: IssueSsoCodeInput,
): Promise<SsoCodeResult> {
  const { data } = await apiClient.post<SsoCodeResult>(
    '/auth/sso/codes',
    input,
    { headers: { 'x-scope-id': input.scopeId } },
  );
  return data;
}
